import type { UserWithAssignmentDTO } from "@/modules/assign-position/domain/contracts";
import { formatSalaryGradeCodeLabelDisplay } from "@/shared/lib/format-salary-grade-display";

/** ບັນທຶກສະແດງລະດັບເງິນເດືອນຈາກມອບໝາຍຫຼັກ — ບໍ່ມີຕໍາແໜ່ງ return null */
export function formatCurrentSalaryGradeLine(
  employee: UserWithAssignmentDTO,
): string | null {
  if (!employee.currentPositionId) return null;
  return formatSalaryGradeCodeLabelDisplay(
    employee.currentSalaryGradeCode,
    employee.currentSalaryGradeLabel,
  );
}
